module.exports = __webpack_public_path__ + "images/e5b892fb9f06ccb014b324ccfbc7a4c86713e666c2ad52a6e20a07aeb25ec60d.svg";